export interface IRideitPassenger {
  id: string;
  instanceid: number;
  movitId: number;
  name: string;
  email: string;
  phone: string;
}

export class RideitPassenger implements IRideitPassenger {
  id: string;
  instanceid: number;
  movitId: number;
  name: string;
  email: string;
  phone: string;

  constructor(data?: IRideitPassenger | null) {
    this.id = data?.id ?? '';
    this.instanceid = data?.instanceid ?? 0;
    this.movitId = data?.movitId ?? 0;
    this.name = data?.name ?? '';
    this.email = data?.email ?? '';
    this.phone = data?.phone ?? '';
  }
}

export default RideitPassenger;